import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export { GetWageSupplementConfigurations, GetWageSupplementConfigurationById, AddWageSupplementConfiguration, SaveWageSupplementConfiguration, DeleteWageSupplementConfiguration }

function GetWageSupplementConfigurations(contractNumber, versionNumber, editionId, configurationId, onSuccess, onError){
    var headers = getAuthHeader();
    axios
      .get(
        process.env.VUE_APP_BASE_API_URL +
          `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/configuration/${configurationId}/wagesupplementconfigurations`,
        headers
      )
      .then((response) => {
        onSuccess(response.data);
      })
      .catch(function(error) {
        if (error.response) {
          // The request was made and the server responded with a status code
          onError(error.response.data);
        } else if (error.request) {
          // The request was made but no response was received
          onError(error.response);
        } else {
          // Something happened in setting up the request that triggered an Error;
          onError(error.message);
        }
        onError(error.config);
      });
}

function GetWageSupplementConfigurationById(contractNumber, versionNumber, editionId, configurationId, wageSupplementConfigurationId, onSuccess, onError){
    var headers = getAuthHeader();
    axios
      .get(
        process.env.VUE_APP_BASE_API_URL +
          `/contracts/${contractNumber}` +
          `/versions/${versionNumber}` +
          `/editions/${editionId}` +
          `/configuration/${configurationId}` +
          `/wagesupplementconfigurations/${wageSupplementConfigurationId}`,
        headers
      )
      .then((response) => {
        onSuccess(response.data);
      })
      .catch(function(error) {
        if (error.response) {
          // The request was made and the server responded with a status code
          onError(error.response.data);
        } else if (error.request) {
          // The request was made but no response was received
          onError(error.response);
        } else {
          // Something happened in setting up the request that triggered an Error;
          onError(error.message);
        }
        onError(error.config);
      });
}

function AddWageSupplementConfiguration(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  wageSupplementConfigurationObject,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionId}/configuration/${configurationId}/wagesupplementconfigurations`,
        wageSupplementConfigurationObject,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function SaveWageSupplementConfiguration(
  contractNumber,
  versionNumber,
  editionId,
  configurationId,
  wageSupplementConfigurationId,
  wageSupplementConfigurationObject,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}` +
        `/versions/${versionNumber}` +
        `/editions/${editionId}` +
        `/configuration/${configurationId}` +
        `/wagesupplementconfigurations/${wageSupplementConfigurationId}`,
        wageSupplementConfigurationObject,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function DeleteWageSupplementConfiguration(contractNumber, versionNumber, editionId, configurationId, wageSupplementConfigurationId, onSuccess, onError){
  var headers = getAuthHeader();
  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}`+
        `/versions/${versionNumber}` +
        `/editions/${editionId}` +
        `/configuration/${configurationId}` +
        `/wagesupplementconfigurations/${wageSupplementConfigurationId}`,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function(error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        onError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        onError(error.response);
      } else {
        // Something happened in setting up the request that triggered an Error;
        onError(error.message);
      }
      onError(error.config);
    });
}